<template>
  <div>
    <headerTop></headerTop>
    <div class="refundHeader">
      <div class="header">
        <img src="@/assets/images/home/logo1.png" alt="" />
        <h2>理赔申请</h2>
      </div>
    </div>
    <div class="content">
      <claim-state :step="'3'" v-if="orderClaimDataVO.state === 16|| orderClaimDataVO.state === 17 || orderClaimDataVO.state === 13"></claim-state>
      <claim-state :step="'4'" v-if="orderClaimDataVO.state === 5"></claim-state>
      <div class="content_con">
        <section>
          <div v-if="orderClaimDataVO.state === 17" style="border-bottom: 1px solid #d7d7d7;height: 50px;line-height: 50px;padding-left: 31px;">
            <img src="@/assets/images/claim/对勾.svg" alt="" style="vertical-align:text-bottom;width:25px;margin-right:10px">
            <span style="font-size: 17px;font-weight:700">理赔同意</span>
          </div>
          <div v-if="orderClaimDataVO.state === 16" style="border-bottom: 1px solid #d7d7d7;height: 50px;line-height: 50px;padding-left: 31px;">
            <img src="@/assets/images/claim/false.svg" alt="" style="vertical-align:text-bottom;width:25px;margin-right:10px">
            <span style="font-size: 17px;font-weight:700">等待卖家处理....</span>
            <Button type="primary" style="margin-left:30px" @click = handle(5)>受理</Button>
            <Button style="margin-left:30px" @click = "modal = true">拒绝</Button>
          </div>
          <div v-if="orderClaimDataVO.state === 13" style="border-bottom: 1px solid #d7d7d7;height: 50px;line-height: 50px;padding-left: 31px;">
            <img src="@/assets/images/claim/false.svg" alt="" style="vertical-align:text-bottom;width:25px;margin-right:10px">
            <span style="font-size: 17px;font-weight:700">理赔拒绝</span>
            <span style="margin-left:30px">拒绝原因：{{formInline.refuseCause}}</span>
          </div>
          <div v-if="orderClaimDataVO.state === 12" style="border-bottom: 1px solid #d7d7d7;height: 50px;line-height: 50px;padding-left: 31px;">
            <img src="@/assets/images/claim/false.svg" alt="" style="vertical-align:text-bottom;width:25px;margin-right:10px">
            <span style="font-size: 17px;font-weight:700">已撤销</span>
          </div>
          <!-- <p class="main_title">*信息缺失会妨碍分析过程,因此这可能会导致拒赔。 例如：不能简单描述为不能工作、压力不足，需要详细描述故障过程，或提供故障检测截屏。</p> -->
          <div style="margin-top: 30px;padding-left: 20px">
            <span style="display: inline-block;width: 108px;text-align: right;"><span>*</span>服务类型:</span>
            <span style="margin-left: 17px;">理赔申请</span>
          </div>
          <div style="margin-top: 30px;padding-left: 20px">
            <Form ref="form" :model="formInline" :rules="ruleInline" :label-width="122" inline>
              <FormItem prop="oeCode" label="OE号/品牌编码:">
                <Input disabled type="text" v-model="formInline.oeCode" style="width: 250px">
                </Input>
              </FormItem>
              <FormItem prop="partName" label="产品名称:">
                <Input disabled type="text" v-model="formInline.partName" style="width: 250px">
                </Input>
              </FormItem>
              <FormItem prop="batchCode" label="批次号:">
                <Input disabled type="text" v-model="formInline.batchCode" style="width: 250px">
                </Input>
              </FormItem>
              <FormItem prop="carBrandName" label="安装车型:">
                <Input disabled type="text" v-model="formInline.carBrandName" style="width: 250px">
                </Input>
              </FormItem>
              <FormItem prop="displacement" label="发动机排量:">
                <Input disabled type="text" v-model="formInline.displacement" style="width: 250px">
                </Input>
              </FormItem>
              <FormItem prop="invoice" label="发票信息:">
                <Input disabled type="text" v-model="formInline.invoice" style="width: 250px">
                </Input>
              </FormItem>
              <FormItem prop="installTime" label="安装日期:">
                <DatePicker disabled type="datetime" v-model="formInline.installTime" format="yyyy-MM-dd" style="width: 250px" />
              </FormItem>
              <FormItem prop="disassembleTime" label="拆卸日期:">
                <DatePicker disabled type="date" v-model="formInline.disassembleTime" format="yyyy-MM-dd" style="width: 250px" />
              </FormItem>
              <FormItem prop="vehicleAnnualPayment" label="车辆车款:">
                <Input disabled type="text" v-model="formInline.vehicleAnnualPayment" style="width: 250px">
                </Input>
              </FormItem>
              <FormItem prop="installedMileage" label="安装里程:">
                <Input disabled type="text" v-model="formInline.installedMileage" style="width: 250px">
                </Input>
              </FormItem>
              <FormItem prop="disassemblyMileage" label="拆卸里程:">
                <Input disabled type="text" v-model="formInline.disassemblyMileage" style="width: 250px">
                </Input>
              </FormItem>
              <FormItem prop="vin" label="VIN码:">
                <Input disabled type="text" v-model="formInline.vin" style="width: 250px">
                </Input>
              </FormItem>
            </Form>
            <span style="display:inline-block;width:120px;text-align:right">理赔说明：</span>
            <Input disabled v-model="reason" maxlength="200" show-word-limit type="textarea" placeholder="请输入理赔说明" style="width: 400px" />
            <div style="margin-top:30px">
              <span style="display:inline-block;width:111px;text-align:right;margin-right:9px">图片上传类型:</span>
              <Select v-model="installType" style="width:200px" disabled>
                <Option v-for="item in installList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </div>
            <div style="margin-top:30px;display:flex">
               <div style="width:120px" v-if="installType === '0'">
                <div style="text-align:right"><span style="color:#ed4014">*</span>包装图片：</div>
                <div style="font-family: cursive">产品外包装、内部填充防护（如没有，不需要）</div>
              </div>
              <div style="width:120px" v-else>
                <div style="text-align:right"><span style="color:#ed4014">*</span>产品图片：</div>
                <div style="font-family: cursive">产品照片、失效位置照片（如：泄漏点，尺寸异常位置，变形或破损位置）</div>
              </div>
              <div class="Uploadshop">
                <div
                  class="Anrikshow"
                  v-for="item in certificatelist"
                  :key="item"
                >
                  <img class="showimg" :src="item" alt="" />
                </div>
              </div>
            </div>
            <div style="margin-top:30px;display:flex">
              <div style="width:120px" v-if="installType === '0'">
                <div style="text-align:right"><span style="color:#ed4014">*</span>配件图片：</div>
                <div style="font-family: cursive">破损产品整体、破损位置</div>
              </div>
              <div style="width:120px" v-else>
                <div style="text-align:right"><span style="color:#ed4014">*</span>标签图片：</div>
                <div style="font-family: cursive">产品标签或者喷码信息、激光刻印信息</div>
              </div>
              <div class="Uploadshop">
                <div
                  class="Anrikshow"
                  v-for="item in partcatelist"
                  :key="item"
                >
                  <img class="showimg" :src="item" alt="" />
                </div>
              </div>
            </div>
            <div style="margin-top:30px;display:flex">
              <div style="width:120px"  v-if="installType === '0'">
                <div style="text-align:right"><span style="color:#ed4014">*</span>标签图片：</div>
                <div style="font-family: cursive">产品标签或者喷码信息、激光刻印信息</div>
              </div>
              <div style="width:120px"  v-else>
                <div style="text-align:right"><span style="color:#ed4014">*</span>其他图片：</div>
                <div style="font-family: cursive">提供和故障件相关的其他配件照片（例如：活塞故障，水壶水箱泄漏）</div>
              </div>
              <div class="Uploadshop">
                <div
                  class="Anrikshow"
                  v-for="item in labelcatelist"
                  :key="item"
                >
                  <img class="showimg" :src="item" alt="" />
                </div>
              </div>
            </div>
            <div style="margin-top:30px;display:flex">
              <div style="width:110px;text-align:right">
                <span style="color:#ed4014">*</span>
                <span>理赔商品:</span>
              </div>
              <div style="width: 1000px;margin-left:10px">
                <vxe-table
                  ref="xTable"
                  auto-resize
                  :data="tableData"
                  align="center"
                  class="mytable-style"
                >
                  <vxe-column type="seq" width="60" title="序号">
                  </vxe-column>
                  <vxe-column field="fullName" title="配件名称">
                  </vxe-column>
                  <vxe-column title="发货地">
                    <template v-slot={row}>
                      <span>{{row.shipCity}}{{row.shipStore}}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="partNum" title="购买数量"></vxe-column>
                  <vxe-column field="claimNum" title="理赔数量">
                    <template #header>
                      <span style="color:red">*</span>
                      <span>理赔数量</span>
                    </template>
                    <template v-slot="{ row }">
                      <span>{{row.claimNum}}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="claimCause">
                    <template #header>
                      <span style="color:red">*</span>
                      <span>理赔原因</span>
                    </template>
                    <template v-slot="{ row }">
                      <span>{{row.claimCause}}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="remark" title="备注">
                  </vxe-column>
                  <vxe-column field="methods" title="处理方式">
                    <template v-slot={row}>
                      <span v-if="row.claimManageStatus">{{row.claimManageMode.name}}</span>
                      <span v-else></span>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>
            </div>
            <div style="text-align:center;margin-top: 25px">
              <Button @click="downLoad" style="margin-right:40px">理赔登记表下载</Button>
            </div>
            <p class="p1">订单信息</p>
            <div>
              <section style="display:flex;padding:30px;border-bottom: 1px solid #d7d7d7;">
                <div style="flex:1">
                  <p>
                    <span style="width:100px;display:inline-block;text-align:right">卖家：</span>
                    <span>{{ordersDataVO.buyShopName}}</span>
                  </p>
                  <p style="margin-top:30px">
                    <span style="width:100px;display:inline-block;text-align:right">运费：</span>
                    <span>{{ordersDataVO.freight}}</span>
                  </p>
                </div>
                <div style="flex:1">
                  <p>
                    <span style="width:100px;display:inline-block;text-align:right">订单编号：</span>
                    <span>{{ordersDataVO.ordersCode}}</span>
                  </p>
                  <p style="margin-top:30px">
                    <span style="width:100px;display:inline-block;text-align:right">实付款：</span>
                    <span>{{ordersDataVO.payMoney}}</span>
                  </p>
                </div>
                <div style="flex:1">
                  <p>
                    <span style="width:100px;display:inline-block;text-align:right">商品金额：</span>
                    <span>{{ordersDataVO.goodsAmount}}</span>
                  </p>
                  <p style="margin-top:30px">
                    <span style="width:100px;display:inline-block;text-align:right">商品数量：</span>
                    <span>{{ordersDataVO.count}}</span>
                  </p>
                </div>
              </section>
              <section style="display:flex;padding:30px">
                <div style="flex:1">
                  <p>
                    <span style="width:100px;display:inline-block;text-align:right">理赔单号：</span>
                    <span>{{orderClaimDataVO.ordersCode}}</span>
                  </p>
                  <p style="margin-top:30px">
                    <span style="width:100px;display:inline-block;text-align:right">状态：</span>
                    <span>{{statesList[orderClaimDataVO.state]}}</span>
                  </p>
                </div>
                <div style="flex:1">
                  <p>
                    <span style="width:100px;display:inline-block;text-align:right">服务类型：</span>
                    <span>{{orderClaimDataVO.serviceType}}</span>
                  </p>
                </div>
                <div style="flex:1">
                  <p>
                    <span style="width:100px;display:inline-block;text-align:right">理赔数量：</span>
                    <span>{{orderClaimDataVO.claimNum}}</span>
                  </p>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
    </div>

    <Modal
      v-model="modal"
      width=400
      @on-cancel="rejectReason = '';modal = false"
      @on-ok = "modal = false;handle(2)"
    >
      <h1 style="margin: 10px 0;text-align:center;font-size: 20px;">是否要拒绝申请？</h1>
      <Input v-model="rejectReason" type="textarea" :rows="3" placeholder="请填写拒绝原因" />
    </Modal>
  </div>
</template>
<script>
import headerTop from '@/views/base/common/header-top.vue'
import { applyCliam, applyForClaim, cliamInfo, handleCliam, downLoadCliam } from '@/api/myweb/cliam'
import ClaimState from '../components/claimState.vue'
import { handleFile } from '@/libs/util.js'
export default {
  name:'claim',
  components: {
    headerTop,ClaimState
  },
  data() {
    return {
      statesList: {
        16:'理赔中',
        17:'卖家已同意',
        12:'已撤销',
        13:'已拒绝',
        5: '处理完成'
      },
      ordersId: '',
      ordersDetailId: '',
      ordersCode: '',
      modal: false,
      formInline: {
        oeCode: '',
        partName: '',
        batchCode: '',
        carBrandName: '',
        displacement: '',
        invoice: '',
        installTime: '',
        disassembleTime: '',
        vehicleAnnualPayment: '',
        installedMileage: '',
        disassemblyMileage: '',
        vin: '',
      },
      ruleInline: {
        oeCode: [{ required: true, message: '必填项', trigger: 'blur' }],
        partName: [{ required: true, message: '必填项', trigger: 'blur' }],
        batchCode: [{ required: true, message: '必填项', trigger: 'blur' }],
        carBrandName: [{ required: true, message: '必填项', trigger: 'blur' }],
        displacement: [{ required: true, message: '必填项', trigger: 'blur' }],
        // information: [{ required: true, message: '必填项', trigger: 'blur' }],
        installTime: [{ required: true, message: '必填项', trigger: 'blur' }],
        disassembleTime: [{ required: true, message: '必填项', trigger: 'blur' }],
        installedMileage: [{ required: true, message: '必填项', trigger: 'blur' }],
        disassemblyMileage: [{ required: true, message: '必填项', trigger: 'blur' }],
        vin: [{ required: true, message: '必填项', trigger: 'blur' }],
      },
      reason: '',
      rejectReason: '',
      installList: [
        {value: '0', label:'未安装'},
        {value: '1', label:'已安装'}
      ],
      installType: '0',
      tableData: [],
      ordersDataVO: {},
      orderClaimDataVO: {},
      informationData: {},
      claimNum:'',
      claimReason:'',
      remark: '',
      certificatelist: [],
      partcatelist: [],
      labelcatelist: [],
      options: {
        size: 20,
        fileType: [
          'png',
          'jpg',
          'jpeg',
          'bmp',
          'gif',
          'webp',
          'psd',
          'svg',
          'tiff'
        ],
        pictureClaim: true
      },
    }
  },
  created() {
    if(this.$route.query){
      this.ordersId = this.$route.query.ordersId
      this.ordersDetailId = this.$route.query.ordersDetailId
      this.ordersCode = this.$route.query.code
      this.getCliamInfo()
    }
  },
  methods: {
    // async getCliam() {
    //   let data = {
    //     ordersId:this.ordersId,
    //     ordersDetailId:this.ordersDetailId
    //   }
    //   let res = await applyCliam(data)
    //   console.log(res);
    //   if(res.status) {
    //     this.tableData = res.data.ordersBackGoods
    //     this.informationData = res.data.ordersDataVO
    //   }
    // },
    async getCliamInfo() {
      let data = {
        ordersId: this.ordersId,
        claimDetailId: this.ordersDetailId,
        claimOrdersCode: this.ordersCode
      }
      let res = await cliamInfo(data)
      if(res.status){
        this.formInline = res.data.ordersClaimDetailVO
        this.tableData = res.data.children
        this.ordersDataVO = res.data.ordersDataVO
        this.orderClaimDataVO = res.data.orderClaimDataVO
        this.reason = res.data.ordersClaimDetailVO.claimDescription
        this.installType = res.data.ordersClaimDetailVO.isInstall.toString()
        this.certificatelist = res.data.ordersClaimDetailVO.externalImagesUrl.split(";")
        this.partcatelist = res.data.ordersClaimDetailVO.productImagesUrl.split(";")
        this.labelcatelist = res.data.ordersClaimDetailVO.labelImagesUrl.split(";")
      }
    },
    async handle(v) {
      let data = {
        ordersId: this.ordersId,
        claimDetailId: this.ordersDetailId,
        claimOrdersCode: this.ordersCode,
        type: v
      }
      if(v === 2) data.refuseCause = this.rejectReason
      let res = await handleCliam(data)
      console.log(res)
      if(res.status){
        this.$Message.success('处理完成！')
        location.reload() 
      }
    },
    async downLoad() {
      let data = {
        ordersId: this.ordersId,
        claimOrdersCode: this.ordersCode
      }
      let res = await downLoadCliam(data)
      if(res.status) handleFile(res.data,'理赔登记表')
    }
  }
}
</script>
<style lang="less" scoped>
  .refundHeader {
    padding-bottom: 15px;
    border-bottom: 2px solid #377cf1;
    margin-top: 90px;
    .header {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      h2 {
        height: 40px;
        font-size: 20px;
        font-weight: 600;
        color: #555555;
        padding-top: 15px;
        padding-left: 34px;
      }
    }
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 20px;
    .content_con {
      border: 1px solid #d7d7d7;
      .main_title {
        text-align: center;
        color: red;
        margin-top: 25px;
      }
      .Uploadshop {
        display: flex;
        align-items: center;
        position: relative;
        .Anrikshow {
          position: relative;
          margin-right: 4px;
          height: 100px;
          width: 100px;
          border: 1px solid #ccc;
          .showimg {
            display: inline-block;
            height: 100px;
            width: 100px;
          }
          .deletelogo {
            position: absolute;
            // right: 0px;
            // top: 0px;
            right: -2px;
            top: -7px;
            display: inline-block;
            width: 15px;
            height: 15px;
            line-height: 15px;
            text-align: center;
            cursor: pointer;
            border-radius: 10px;
            color: #fff;
            background-color: red;
          }
        }
        .hint {
          span {
            display: inline-block;
            width: 110px;
            color: #e2e2e2;
            position: absolute;
            bottom: -4px;
            /* margin-left: 5px; */
            font-size: 12px;
          }
        }
      }
    }
    .p1{
      background: rgb(238, 238, 238);
      margin-left: -20px;
      margin-top: 25px;
      height: 45px;
      line-height: 45px;
      font-size: 16px;
      font-weight: 700;
      padding-left: 20px;
      border: 1px solid #d7d7d7;
    }
    .footer {
      margin-top: 25px;
      margin-bottom: 30px;
      li {
        height: 35px;
        line-height: 35px;
        .text {
          display: inline-block;
          width: 300px;
        }
      }
    }
  }
</style>